import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectWebimInfo } from '../../selectors/webim';
import { ChatContainer } from './ChatContainer';

export const WebimChatContainer: React.FC = () => {
  const { accountName, host, webimHash, isVisibleInformer, isVisibleChat } = useSelector(selectWebimInfo);

  if (!accountName || !webimHash || !isVisibleChat) {
    return null;
  }

  return (
    <ChatContainer accountName={accountName} host={host} webimHash={webimHash} isVisibleInformer={isVisibleInformer} />
  );
};
